import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { QueryResponse } from '../../shared/models/query-response';
import { CommandResponse } from 'src/app/shared/models/command-response';
import { API_URLS } from 'src/app/config/api-urls';
import { UserSettings } from './models/userData.model';
import { CountryList } from './countriesList.model';

@Injectable({
  providedIn: 'root'
})
export class HubService {
  private http = inject(HttpClient);

  private hubUserUrl = API_URLS.HUB_USER;
  private updateHubUserUrl = API_URLS.UPDATE_HUB_USER;
  private getCountriesListUrl = API_URLS.COUNTRIES_LIST;

  getUserData() {
    return this.http.get<QueryResponse<UserSettings>>(this.hubUserUrl);
  }

  updateUserSettings(settings: Partial<UserSettings>) {
    return this.http.post<CommandResponse>(this.updateHubUserUrl, settings);
  }

  getCountriesList() {
    return this.http.get<QueryResponse<CountryList[]>>(this.getCountriesListUrl);
  }
}
